'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Checkout = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transform = function transform(_ref) {
    var invoice = _ref.invoice,
        results = _ref.results;
    var balanceDue = invoice.balance_due,
        id = invoice.id,
        invoiceTotal = invoice.invoice_total,
        sent = invoice.is_sent,
        itemTotal = invoice.item_total,
        buyersPremium = invoice.buyers_premium_total,
        currency = invoice.currency,
        otherCharges = invoice.other_charges,
        payments = invoice.payments,
        paymentsTotal = invoice.payments_total,
        processing_fee = invoice.processing_fee,
        sales_tax = invoice.sales_tax,
        shipping_charge = invoice.shipping_charge;


    var items = results.map(function (item) {
        return {
            catalogId: item.catID,
            imageVersion: item.imageVersion,
            itemId: item.lotID,
            salePrice: item.sale_price,
            sellerId: item.houseID,
            sellerName: item.name,
            title: item.title
        };
    });

    return {
        data: {
            invoice: {
                balanceDue: balanceDue,
                buyersPremium: buyersPremium,
                currency: currency.cur_code,
                id: id,
                invoiceTotal: invoiceTotal,
                itemTotal: itemTotal,
                otherCharges: otherCharges,
                payments: payments,
                paymentsTotal: paymentsTotal,
                processingFee: Number(processing_fee),
                salesTax: Number(sales_tax),
                sent: !!sent,
                shipping: Number(shipping_charge)
            },
            items: items
        },
        message: !!id ? 'Successfully retrieved the invoice.' : 'Error getting the invoice',
        success: !!id
    };
};

var Checkout = exports.Checkout = {
    fetchInvoice: function fetchInvoice(_ref2) {
        var authToken = _ref2.authToken,
            bidderId = _ref2.bidderId,
            catalogId = _ref2.catalogId,
            deployment = _ref2.deployment;

        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)({
                authToken: authToken,
                deployment: deployment,
                path: '<MAINHOST-API>api/bidders/' + bidderId + '/wonitems/catalogs/' + catalogId,
                queryParams: { client_version: '5.0', page: 1, pagesize: 1250 }
            });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response, transform: transform });
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/checkout.js
// module id = f9A3
// module chunks = 60